module.exports = __webpack_public_path__ + "img/taketomi_4.8cda07d7.jpg";